const flattenToArrayOfArrays = (data) => {
  const result = [];
  const flatten = (item) => {
    if (
      Array.isArray(item) &&
      item.every((el) => Array.isArray(el) && el.length === 4)
    ) {
      result.push(...item);
    } else if (Array.isArray(item)) {
      item.forEach(flatten);
    } else if (item && typeof item === "object") {
      for (const key in item) {
        if (Object.hasOwn(item, key)) {
          flatten(item[key]);
        }
      }
    }
  };
  if (Array.isArray(data) && data.length > 0 && !Array.isArray(data[0])) {
    data = [data];
  }
  flatten(data);
  return result;
};
const highlightText = (path, highlightMetadata, confidenceMetadata) => {
  const getDataByPath = (metadata) =>
    path.reduce((current, key) => {
      const next = current?.[key];
      if (next) return next;
      if (Array.isArray(current) && current.length === 1) {
        return current[0]?.[key];
      }
      return null;
    }, metadata);

  const target = getDataByPath(highlightMetadata);
  let targetConfidence = getDataByPath(confidenceMetadata);

  // If targetConfidence is an array and has values, use the first item
  targetConfidence =
    Array.isArray(targetConfidence) && targetConfidence.length > 0
      ? targetConfidence[0]
      : targetConfidence;

  if (target || targetConfidence) {
    const newHighlightData = flattenToArrayOfArrays(target);

    if (targetConfidence) {
      const confidenceArray = Object.values(targetConfidence).map((val) =>
        newHighlightData[0].concat(val)
      );

      return [...newHighlightData, ...confidenceArray];
    } else {
      return newHighlightData;
    }
  }
};

export { highlightText };
